import React, { useCallback } from "react";
import _ from 'i18n';
import FrequencyFilter from "../../../Filters/EventStats/EventRegistrantLinechart/FrequencyFilter";
import { Checkbox, DatePicker } from 'antd';
import moment from 'moment';
import LanguagesFilter from "../../../Filters/EventStats/EventRegistrantLinechart/LanguagesFilter";
import RegistrationCAFilter from "../../../Filters/EventStats/EventRegistrantLinechart/RegistrationCAFilter";
import TypeFormatFilter from "../../../Filters/EventStats/EventRegistrantLinechart/TypeFormatFilter";

const { MonthPicker } = DatePicker;

const EventLineChartFilters = ({
  frequency,
  updateFrequency,
  updatePeriod,
  period,
  language,
  languages,
  updateLanguages,
  type,
  legendType,
  updateChartType,
  updateLegendType,
  eventStatsFilter,
  showAccumulateEventStats,
  handleShowAccumulateEventStats,
  fetching,
}) => {
  moment.locale(language);

  // It's optional: select only months of the selected year
  const disabledYears = useCallback((current) => {
    return current.year() != period[0].substr(0, 4);
  }, [period]);

  const handleMonthPickerChange = useCallback((date, dateString) => {
    updatePeriod([dateString]);
  }, [updatePeriod]);

  return (
    <div className={'event-filters-nav'}>
      <div style={{ width: '40%' }}>
        <TypeFormatFilter legendType={legendType} updateLegendType={updateLegendType} />
      </div>
      {eventStatsFilter.year.length === 1 &&
        <div
          className={'flex items-center'}
          style={{ width: '60%', justifyContent: frequency === 'DAILY' ? 'space-between' : 'flex-end' }}
        >
          {/* <div style={{width: '80%'}}>
            <RegistrationCAFilter type={type} updateType={updateChartType}/>
          </div> */}
          {frequency == 'DAILY' &&
            <MonthPicker
              onChange={handleMonthPickerChange}
              defaultValue={moment(period[0], 'YYYY-MM')}
              allowClear={false}
              disabledDate={disabledYears}
              className={'event-registrant-line-chart-month-picker'}
              dropdownClassName={"event-registrant-line-chart-month-picker"}
            />
          }

          {frequency === 'DAILY' &&
            <Checkbox checked={showAccumulateEventStats} onChange={handleShowAccumulateEventStats} style={{ display: 'flex', alignItems: 'center', margin: '0 12px' }}>
              Cumulative
            </Checkbox>
          }

          <div className={'flex'}>
            <LanguagesFilter languages={languages} updateLanguages={updateLanguages} />
            <FrequencyFilter frequency={frequency} updateFrequency={updateFrequency} fetching={fetching} />
          </div>
        </div>
      }
    </div>
  );
};

export default EventLineChartFilters;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChartFilters.js